import classes from "./Comment/CommentField.module.css";
import util from "../styles/utilities.module.css";
import ReactDOM from "react-dom";
const Modal = ({showButtons , children, cancelHandler, saveHandler, removeCategory, removeCategoryHandler}) => {
  return ReactDOM.createPortal(
    <div className={`${util.modalOverlay} ${classes["modal-overlay"]}`}>
      <div  className={`${util.modalSurface} ${!showButtons ? classes.infoModal : classes.generalModal}`}>
        <div>
          {children}

        {showButtons && <div className={ classes.modalButtonsContainer}>    
            {removeCategory ? (
              <button
                onClick={removeCategoryHandler}
                className={`${util.btn} ${util['btn--dangerSubtle']} ${util['btn-sm']}`}
              >
                Remove Category
              </button>
            ) : null}
            <div className={classes.saveCancelContainer}>
              <button
                onClick={cancelHandler}
                className={`${util.btn} ${util['btn--ghost']} ${util['btn-sm']}`}
              >
                Cancel
              </button>
              <button
                onClick={saveHandler}
                className={`${util.btn} ${util['btn--primaryGradient']} ${util['btn-sm']}`}
              >
                Save
              </button>
            </div>
        </div> }


        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
